import styled from 'styled-components';

import { ContainerAccordionProps } from '.';

export const AccordionContainer = styled.div`
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  outline: none;
  padding: ${({ theme }) => theme.yoga.spacing.xsmall}px 0;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  transition: 0.4s;
`;

export const Accordion = styled.div<ContainerAccordionProps>`
  display: ${({ collapsable }) => (collapsable ? 'block' : 'none')};
`;

export const CollapseAccordion = styled.div`
  cursor: pointer;

  svg {
    margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
    height: ${({ theme }) => theme.yoga.spacing.large}px;
    width: ${({ theme }) => theme.yoga.spacing.large}px;

    fill: ${({ theme }) => theme.yoga.colors.primary};
  }
`;
